import React from 'react'
import '../../App.css'
import Imgpro from '../images/Mahendra.png'
import './Profile.css'
export const Profile = () => {
    return (
        <section className="container my-5">
            <div className="m-auto w-75 profile mt-5 p-4">
                <div className="row">
                    <div className="col-md-4">
                        <img src={Imgpro} alt="" />
                    </div>
                    <div className="col-md-6">
                        <div className="pHead mt-4">
                            <span className='subtitle text-muted' >Mahendra gautam</span>
                            <h6><b>CEO</b></h6>
                            <p className='mt-3 mb-5'>RANKING <span>10/10</span></p>

                            <ul className="nav nav-pills mt-3" id="pills-tab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <a  href=" " class="nav-link active" id="pills-about-tab" data-bs-toggle="pill" data-bs-target="#pills-about"  role="tab" aria-controls="pills-about" aria-selected="true">About</a>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <a href=" " class="nav-link " id="pills-timeline-tab" data-bs-toggle="pill" data-bs-target="#pills-timeline"  role="tab" aria-controls="pills-timeline" aria-selected="false">Timeline</a>
                                </li>

                            </ul>
                         
                        </div>
                    </div>
                    <div className="col-md-2">
                        <input type="submit" className='profile-edit-btn mt-4' value="Edit profile" />
                    </div>
                    <div className="row find">
                        <div className="col-md-4 text-center">
                            <span className="subtitle">Find me here</span>
                            <ul className='list-unstyled mb-5'>
                                <li><a href="www.youtube.com">Youtube</a></li>
                                <li><a href="www.youtube.com">Facebook</a></li>
                                <li><a href="www.youtube.com">Github</a></li>
                                <li><a href="www.youtube.com">Instagram</a></li>
                                <li><a href="www.youtube.com">Twiter</a></li>
                            </ul>
                        </div>
                        <div className="col-md-8 col-sm-center">
                        <div class="tab-content" id="pills-tabContent">
                                <div class="tab-pane fade show active" id="pills-about" role="tabpanel" aria-labelledby="pills-about-tab">
                                    <div className="row">
                                        <div className="col-md-6">
                                        <strong><label htmlFor="">User-id</label></strong>

                                        </div>
                                        <div className="col-md-6">
                                            <p>4567890</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                        <strong><label htmlFor="">Name</label></strong>
                                        </div>
                                        <div className="col-md-6">
                                            <p>Mahendra Gautam</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                        <strong><label htmlFor="">E-mail</label></strong>
                                        </div>
                                        <div className="col-md-6">
                                            <p>example123@gmail.com</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                        <strong><label htmlFor="">Contact no</label></strong>
                                        </div>
                                        <div className="col-md-6">
                                            <p>9821550276</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                        <strong><label htmlFor="">Profession</label></strong>
                                        </div>
                                        <div className="col-md-6">
                                            <p>Enterpreneur</p>
                                        </div>
                                    </div>

                                </div>
                                <div class="tab-pane fade" id="pills-timeline" role="tabpanel" aria-labelledby="pills-timeline-tab">
                                <div className="row">
                                        <div className="col-md-6">
                                        <strong><label htmlFor="">Experience</label></strong>

                                        </div>
                                        <div className="col-md-6">
                                            <p>Expert</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                        <strong><label htmlFor="">Investment</label></strong>
                                        </div>
                                        <div className="col-md-6">
                                            <p>Rs:1000000</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                        <strong><label htmlFor="">Projects</label></strong>
                                        </div>
                                        <div className="col-md-6">
                                            <p>97</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                        <strong><label htmlFor="">English</label></strong>
                                        </div>
                                        <div className="col-md-6">
                                            <p>Expert</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                        <strong><label htmlFor="">Availability</label></strong>
                                        </div>
                                        <div className="col-md-6">
                                            <p>3 years</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
